module.exports = __webpack_public_path__ + "static/img/ubuntu.a35a9358.png";